<template>
    <div class="choose-printer__file">
        <h3 class="text--500" v-for="(file, index) in files" :key="index">{{file.filename}}</h3>
    </div>
</template>

<script>
    export default {
        name: "FileList",
        props: ['files']
    }
</script>

<style scoped>

</style>
